import { render, staticRenderFns } from "./SerieDetailsView.vue?vue&type=template&id=9e1a4d76&"
import script from "./SerieDetailsView.vue?vue&type=script&lang=js&"
export * from "./SerieDetailsView.vue?vue&type=script&lang=js&"
import style0 from "./SerieDetailsView.vue?vue&type=style&index=0&id=9e1a4d76&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports